var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),(_vm.consentBannerEnabled)?_c('consent-banner',{attrs:{"home-id":_vm.routeHomeId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }